import {NgModule} from '@angular/core';
import {PublishProjectModalComponent} from './projects/publish-project-modal/publish-project-modal.component';
import {MaterialModule} from '../material.module';
import {CommonModule} from '@angular/common';
import {UiModule} from 'common/core/ui/ui.module';
import {FormsModule} from '@angular/forms';
import {CrupdateProjectModalComponent} from './crupdate-project-modal/crupdate-project-modal.component';

@NgModule({
    imports: [
        CommonModule,
        UiModule,
        FormsModule,
        MaterialModule,
    ],
    declarations: [
        PublishProjectModalComponent,
        CrupdateProjectModalComponent,
    ],
    entryComponents: [
        PublishProjectModalComponent,
        CrupdateProjectModalComponent,
    ],
})
export class SharedModule {
}
